import React from "react";
import Nav from "../components/Nav";

export default function DataDeletion() {
  return (
    <div className="bg-bg min-h-screen text-text">
      <Nav />
      <div className="container mx-auto max-w-3xl px-6 py-20">
        <h1 className="font-heading text-[clamp(28px,4vw,40px)] font-bold leading-tight -tracking-[0.03em]">
          Data Deletion Instructions
        </h1>
        <p className="mt-3 text-[14px] text-muted">
          Last updated: 17 June 2026
        </p>

        <div className="mt-8 space-y-8 text-[14px] font-light leading-[1.75] text-muted">
          <p>
            If you would like us to delete your personal data from our systems,
            you can request deletion using one of the methods below.
          </p>

          <div>
            <h2 className="mb-3 font-heading text-[16px] font-bold -tracking-[0.02em] text-text">
              Option 1: Email request
            </h2>
            <p>
              Send an email to{" "}
              <a
                href="mailto:hello@labradical.com.au?subject=Data%20Deletion%20Request"
                className="text-lime underline transition-opacity hover:opacity-80"
              >
                hello@labradical.com.au
              </a>{" "}
              with the subject line{" "}
              <strong className="font-medium text-text">
                "Data Deletion Request"
              </strong>
              . Please include your name, email address used to contact us, and
              any relevant details to help us locate your data.
            </p>
          </div>

          <div>
            <h2 className="mb-3 font-heading text-[16px] font-bold -tracking-[0.02em] text-text">
              Option 2: Privacy Policy page
            </h2>
            <p>
              Visit our{" "}
              <a
                href="/privacy"
                className="text-lime underline transition-opacity hover:opacity-80"
              >
                Privacy Policy page
              </a>{" "}
              and email us from there using the contact information provided.
            </p>
          </div>

          <div>
            <h2 className="mb-3 font-heading text-[16px] font-bold -tracking-[0.02em] text-text">
              What happens next
            </h2>
            <ul className="list-disc space-y-1.5 pl-5">
              <li>
                We will acknowledge your request within 2 business days.
              </li>
              <li>
                We will delete your personal data within 30 days, unless we need
                to retain it for legal compliance or fraud prevention.
              </li>
              <li>
                We will confirm once the deletion is complete.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="mb-3 font-heading text-[16px] font-bold -tracking-[0.02em] text-text">
              Data we may retain
            </h2>
            <p>
              In some cases, we may need to retain certain information as
              required by Australian law (e.g., tax records, business
              communications). If we cannot fulfil your deletion request due to
              a legal obligation, we will explain why in our response.
            </p>
          </div>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-[13px] text-muted">
            lab.radical · Sydney, Australia ·{" "}
            <a
              href="mailto:hello@labradical.com.au"
              className="text-lime underline transition-opacity hover:opacity-80"
            >
              hello@labradical.com.au
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
